var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_10252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52078 14.8768C11.3166 14.8768 14.3938 11.7996 14.3938 8.00376C14.3938 4.20789 11.3166 1.13074 7.52078 1.13074C3.72492 1.13074 0.647766 4.20789 0.647766 8.00376C0.647766 11.7996 3.72492 14.8768 7.52078 14.8768Z",
    fill: "#FFEE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52078 1.13074V14.8767C11.3166 14.8767 14.3938 11.7996 14.3938 8.00372C14.3938 4.20783 11.3166 1.13074 7.52078 1.13074Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5208 15.5C3.38734 15.5 0.0245056 12.1372 0.0245056 8.00374C0.0245056 3.87029 3.38734 0.507446 7.5208 0.507446C11.6542 0.507446 15.0171 3.87029 15.0171 8.00374C15.0171 12.1372 11.6542 15.5 7.5208 15.5ZM7.5208 1.75403C4.07469 1.75403 1.27105 4.55767 1.27105 8.00378C1.27105 11.4499 4.07469 14.2535 7.5208 14.2535C10.9669 14.2535 13.7705 11.4499 13.7705 8.00378C13.7705 4.55767 10.9669 1.75403 7.5208 1.75403Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31882 7.33507H7.03613C6.76131 7.33507 6.53772 7.11148 6.53772 6.83666C6.53772 6.56184 6.76131 6.3383 7.03613 6.3383H9.20174V5.09176H8.1436V4.31018H6.89706V5.09724C5.99968 5.16834 5.29123 5.92129 5.29123 6.83662C5.29123 7.79878 6.07401 8.58157 7.03617 8.58157H8.31886C8.61869 8.58157 8.8626 8.82551 8.8626 9.1253C8.8626 9.42514 8.61865 9.66909 8.31886 9.66909H5.55487V10.9156H6.8971V11.6972H8.14364V10.9156H8.31886C9.30604 10.9156 10.1091 10.1125 10.1091 9.1253C10.1091 8.13821 9.30595 7.33507 8.31882 7.33507Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46857 7.38098H3.71519V8.62752H2.46857V7.38098Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3264 7.38H12.573V8.62654H11.3264V7.38Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3264 7.38H12.573V8.62654H11.3264V7.38Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52078 0.507507V1.75405C10.9669 1.75405 13.7705 4.55769 13.7705 8.0038C13.7705 11.4499 10.9669 14.2535 7.52078 14.2535V15.5001C11.6542 15.5001 15.0171 12.1372 15.0171 8.0038C15.0171 3.87035 11.6542 0.507507 7.52078 0.507507Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20174 6.33832V5.09178H8.14359V4.31024H7.52078V6.33832H9.20174Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14359 10.9157H8.31882C9.30599 10.9157 10.1091 10.1125 10.1091 9.12536C10.1091 8.13819 9.30595 7.33508 8.31882 7.33508H7.52078V8.58162H8.31882C8.61865 8.58162 8.86255 8.82557 8.86255 9.12536C8.86255 9.42519 8.61861 9.66914 8.31882 9.66914H7.52078V11.6973H8.14359V10.9157Z",
    fill: "#FFBB33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_10252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9584,
    height: 15,
    fill: "white",
    transform: "translate(0.0415649 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.3260133e287de4eb83555ce02f8c9fa4.svg";
export { ForwardRef as ReactComponent };